import Cookies from 'js-cookie'
import loadScript from 'simple-load-script'
import { v4 as UUIDv4 } from 'uuid'
import { getEnvVar } from '@mc/client-env'
import request, { params } from './authApiService'

const isEnabled = () =>
  window.AppleID && getEnvVar('APPLE_SIGN_IN_CLIENT_ID_WEB')

export const initAppleSignIn = async () => {
  await loadScript(
    'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js',
  )
  if (isEnabled()) {
    const state = UUIDv4()
    Cookies.set('apple_sign_in_state', state)
    window.AppleID.auth.init({
      clientId: getEnvVar('APPLE_SIGN_IN_CLIENT_ID_WEB'),
      redirectURI: getEnvVar('APPLE_SIGN_IN_WEB_REDIRECT_URI'),
      scope: 'name email',
      state,
      usePopup: true,
    })
  }
}

export const appleSignIn = () => {
  if (isEnabled()) {
    return window.AppleID.auth.signIn()
  }
  return null
}

export const appleAuth = ({ user, authorization }) => {
  const urlParams = new URLSearchParams(document.location.search)
  const nextPage = urlParams.get('next_page') || ''
  const data = {
    ...authorization,
    next_page: nextPage,
  }
  if (user) {
    data.user = JSON.stringify(user)
  }
  return request('/user_sessions/create', params(data))
}
